import { useTranslation } from 'react-i18next'
import type { PackagingHeavyMetalsAuditResult } from '@/shared/hooks/api/packagingSuppliers'

type PackagingHeavyMetalsAuditRunResultsProps = {
  result: PackagingHeavyMetalsAuditResult
}

export function PackagingHeavyMetalsAuditRunResults({
  result,
}: PackagingHeavyMetalsAuditRunResultsProps) {
  const { t } = useTranslation('packagingSuppliers')

  return (
    <div className='space-y-4 text-sm'>
      <div>
        <p className='font-medium text-foreground'>
          {t(`itemDetail.heavyMetalsAudit.verdicts.${result.verdict}`)}
        </p>
      </div>
      <div className='space-y-2'>
        <p className='font-medium'>{t('itemDetail.heavyMetalsAudit.reasoningEn')}</p>
        <p className='text-muted-foreground'>{result.reasoningEn}</p>
      </div>
      <div className='space-y-2'>
        <p className='font-medium'>{t('itemDetail.heavyMetalsAudit.reasoningZh')}</p>
        <p className='text-muted-foreground'>{result.reasoningZh}</p>
      </div>
      {result.evidenceDocumentIds.length > 0 ? (
        <div className='space-y-2'>
          <p className='font-medium'>
            {t('itemDetail.heavyMetalsAudit.evidenceDocuments')}
          </p>
          <ul className='list-disc space-y-0.5 ps-5 text-muted-foreground'>
            {result.evidenceDocumentIds.map((documentId) => (
              <li key={documentId}>{documentId}</li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  )
}
